export const FaqItems = [
  {
    id: "faq-what-is-an-onelink",
    title: "What is an Onelink from Onelink.to",
    items: [
      {
        id: "what-is-onelink-to",
        title: "What is Onelink.to?",
        content: [
          'Onelink.to is a web based service for smart download links that simplifies the distribution and downloading of apps for mobile devices.\n\nInstead of needing multiple download links or QR codes for your app, you only need one smart download short link (or QR code) from Onelink.to.\n\nYou add the download links to Google Play, Apple AppStore, etc; and we make sure to send each user clicking the smart Onelink.to link (or scanning the QR code) to the correct app store/marketplace depending on what device is being used. Or to your homepage or similar if it is not a mobile device (using a "Fallback URL").\n\nOnelink.to launched in 2011 and is one of the first services offering smart download links.',
        ],
        tags: ["onelink"],
      },
      {
        id: "what-is-an-onelink",
        title: "What is an Onelink from Onelink.to?",
        content: [
          "An Onelink is a smart download short link from Onelink.to. With an Onelink you only need one link or QR code to all app stores. There is no need to print multiple QR codes, or have multiple download links in your email marketing. We will make sure to send the user to the correct app store / marketplace based on the device used.",
        ],
        tags: ["onelink", "short link"],
      },
      {
        id: "why-use-an-onelink",
        title: "Why use an Onelink?",
        content: [
          "An Onelink is a smart download short link from Onelink.to. With an Onelink you only need one link or QR code to all app stores. There is no need to print multiple QR codes, or have multiple download links in your email marketing. We will make sure to send the user to the correct app store / marketplace based on the device used.\n\nAnother great thing with an Onelink is that it is a dynamic short link, meaning that you can change your app download links at any time, without your Onelink changing. E.g. you can start with only App Store and add Google Play when the Android version is available.",
        ],
        tags: ["onelink", "qr code", "short link"],
      },
      {
        id: "is-an-onelink-a-qr-code-or-a-short-link",
        title: "Is an Onelink a QR code or a short link?",
        content: [
          "You can use your Onelink as either a QR code or a short link (or both). In the Onelink.to console, you can download the QR code to each Onelink in PNG or SVG format.",
        ],
        tags: ["onelink", "qr code", "short link"],
      },
      {
        id: "what-is-the-best-way-to-link-to-an-app",
        title: "What is the best way to link to an app?",
        content: [
          "If you have an app and want a simple solution for linking to that app on both App Store and Google Play, then you can create an Onelink from Onelink.to. You automatically get a QR code and short link and Onelink.to makes sure that the user is sent to the correct appstore/marketplace depending on what device is being used.",
        ],
        tags: ["onelink", "qr code", "short link"],
      },
      {
        id: "what-are-the-use-cases-for-an-onelink",
        title: "What are the use cases for an Onelink?",
        content: [
          "The main benefit of an Onelink from Onelink.to is that it simplifies app downloads, removing the need to consider what device someone is using. Onelink.to will automatically send each user to Appstore or Google Play etc, depending on what device is being used. On top of that you get a dynamic link and QR code, and statistics.\n\nThe use cases are numerous, but the most common are:\n<ul><li>Email and SMS marketing and direct messaging</li><li>Web based banner or link advertising using shortlinks</li><li>Printed advertising with QR codes, in newspapers, outdoor advertising, etc</li><li>Digital signage advertising with QR codes</li><li>App download shortcuts in printed material (manuals, product sheets, etc) using QR codes</li></ul>Try creating an Onelink today, start free.",
        ],
        tags: ["onelink", "qr code"],
      },
    ],
  },
  {
    id: "faq-onelink-howto",
    title: "How to work with Onelinks",
    items: [
      {
        id: "how-do-i-create-an-onelink",
        title: "How do I create an Onelink?",
        content: [
          "First you need to sign up for an Onelink.to account, free or paid. After that you can create a new Onelink from the My Onelinks page.\n\nYou just need to add the download links for Apple App Store, Google Play and any other app store you use.\n\nAfter that you can start to use your Onelink using the QR code or short link.",
        ],
        tags: ["work with onelinks"],
      },
      {
        id: "where-can-i-find-the-link-to-my-app-on-app-store",
        title: "Where do I find the link to my app on App Store?",
        content: [
          '<ol><li>Log in to <a href="https://appstoreconnect.apple.com/" target="_blank" rel="noopener">App Store Connect</a></li><li>Go to <strong>My Apps</strong> and click on you app.</li><li>Click on <strong>General > App Information</strong>.</li><li>Click on <strong>Additional Information > View on App Store</strong>.</li><li>Copy the URL of the page.</li></ol>',
        ],
        tags: ["work with onelinks"],
      },
      {
        id: "where-can-i-find-the-link-to-my-app-on-google-play",
        title: "Where do I find the link to my app on Google Play?",
        content: [
          '<ol><li>Log in to the <a href="https://play.google.com/console" target="_blank" rel="noopener">Google Play Console</a></li><li>Go to <strong>All apps</strong> and click on you app.</li><li>Click on <strong>View on Google Play</strong> next to the app title.</li><li>Copy the URL of the page.</li></ol>',
        ],
        tags: ["work with onelinks"],
      },
    ],
  },
  {
    id: "faq-my-onelink-account",
    title: "My Onelink Account",
    items: [
      {
        id: "google-email-address-has-changed",
        title: "My Google email address has changed, what do I do?",
        content: [
          'Did you register using Google Sign Up and now your Google email address have changed?\n\nAs long as you still can receive emails on the original email address there is a solution.\n\n1. Generate a password to your old email address by clicking the "Forgot Password" button on the Login page.\n\n2. When the new password is set and you are logged in. Go to the User Settings (click your name / email address on the top right) and request to change email to your new Google email address.\n\nAfter the email is updated you can login using Google login and your new email address.',
        ],
        tags: ["email address", "account"],
      },
      {
        id: "multiple-users-on-same-account",
        title: "Can my colleague and I use the same account?",
        content: [
          "Yes, upgrade to the Team plan and you can have several users on the same account.",
        ],
        tags: ["account"],
      },
      {
        id: "cant-find-my-legacy-onelink",
        title:
          "I created an Onelink smart download link a while ago, but now I can't find it",
        content: [
          "On our old legacy service it was possible to create links without signing in. Please send us an email on support@onelink.to and we'll do our best to help.",
        ],
        tags: ["onelink"],
      },
    ],
  },
  {
    id: "faq-onelink-statistics",
    title: "Onelink Statistics",
    items: [
      {
        id: "what-statistics-is-available-from-the-onelink-usage",
        title: "What statistics is available from the Onelink usage?",
        content: [
          "We will save a lot of different statistics when someone scans your Onelink QR code or clicks the shortlink.\n\nAll plans\n• Device click tracking - How many clicks or QR scans your Onelink generates, per device type (iOS, Android, etc).\n\nProfessional Plan and up\n• Redirect tracking - What was the result of the click/scan.\n• Referrer tracking - Which website is the click coming from (if applicable).\n• Country tracking - Where does the click/scan come from.\n\nTeam Plan and up\n• UTM tracking - Tracking of UTM parameters added to the Onelink shortlink when it was clicked or the QR code was scanned.",
        ],
        tags: ["statistics"],
      },
      {
        id: "what-is-utm-tracking",
        title: "What is UTM tracking?",
        content: [
          "UTM tracking uses standardized parameters added to web links to collect campaign data.\n\nThe available UTM parameters are:\n• utm_source\n• utm_medium\n• utm_campaign\n• utm_term\n• utm_content\n\nAn example would be:\nhttps://onelink.to/mycode?utm_source=email&utm_campaign=50-percent-off\n\nUTM tracking is available with the Team plan and up, and there is an integrated UTM campaign tool available on the site.",
        ],
        tags: ["statistics"],
      },
      {
        id: "how-do-i-use-utm-tracking-with-onelink-to",
        title: "How do I use UTM tracking with Onelink.to?",
        content: [
          "With the Team Plan you will be able to track any UTM parameter you add to your onelink.to-URL when using it, such as http://onelink.to/mycode?utm_source=facebook&utm_campaign=video1\n\nI.e. you add your UTM campaign parameters to the link before adding it to your website, advertising campaign, or similar.\n\nThe available UTM parameters are:\n• utm_source\n• utm_medium\n• utm_campaign\n• utm_term\n• utm_content\n\nWith the UTM campaign tool available on the site, you can create UTM trackable onelinks and QR codes.",
          "utm_campaign_tool.png",
          "After adding the UTM parameters, you must save the Onelink URL with the UTM parameters, or download the QR code, and use those. UTM tracking will only work when the UTM parameters are available in the link or QR code that is used.",
        ],
        tags: ["statistics"],
      },
    ],
  },

  {
    id: "faq-shortlinks-and-qr-codes",
    title: "Short links and QR codes",
    items: [
      {
        id: "what-is-a-smart-download-link",
        title: "What is a smart download link?",
        content: [
          "A smart download link is a short link used to simplify app downloads on smartphones. When someone clicks the smart download link, the server identifies what device is being used, and sends the device to the correct app store / marketplace.\n\nOnelink.to launched in 2011 and is one of the first services offering smart download links.",
        ],
        tags: ["short link"],
      },
      {
        id: "what-is-a-qr-code",
        title: "What is a QR code?",
        content: [
          "A QR code, or Quick Response Code, is a more advanced type of bar code that contains a small amount of digital information, for example a link to a website or a digital business card.\n\nOn many mobile phones, you can scan a QR code directly in the camera app, or by using a downloaded QR scanner app, making them very easy to interact with.",
        ],
        tags: ["qr code"],
      },
      {
        id: "what-is-a-dynamic-qr-code",
        title: "What is a dynamic QR code?",
        content: [
          "A Dynamic QR code is essentially the same as a regular QR code. The difference is that instead of having the QR code contain the target content, like a web link, it contains a short link that leads you to the target content. The main benefit is that this makes the QR code action changable, i.e. dynamic. Another benefit is that you can find out how many persons scan your QR code.",
        ],
        tags: ["qr code", "short link"],
      },
      {
        id: "what-is-a-short-link",
        title: "What is a short link?",
        content: [
          "A short link is like a shortcut for the web. A regular link to some specific content on the web is normally pretty long and sometimes unpractical to share. An URL shortener (service) handles that problem by wrapping the original long link in a short link package. When someone click the short link, the browser will first go to the URL shortener service and then bounce to the original link (target URL).\n\nIf you are able to edit the target URL, you have a dynamic short link, which is great for printed QR codes. Another benefit is that you can find out how many persons click your link, if you can't track the original link.",
        ],
        tags: ["short link"],
      },
      {
        id: "what-is-a-dynamic-short-link",
        title: "What is a dynamic short link?",
        content: [
          "A dynamic short link is a short link where you can edit the target URL without the short link changing. This is great for printed QR codes.",
        ],
        tags: ["short link"],
      },
      {
        id: "what-is-a-smart-short-link",
        title: "What is a smart short link?",
        content: [
          "A smart short link is designed to be more versatile and dynamic than a regular short link. Both provide a shortened version of an URL, but a smart short link allows for much more functionality. It allows the creator of the link to track clicks, redirect users to different pages based on their device or location, and provide additional functionality such as analytics and A/B testing.\n\nA regular short link, on the other hand, is simply a shortened version of a URL that redirects users to the original website or page. It does not provide any additional functionality beyond redirecting users to the original link.\n\nSmart short links also have the ability to redirect the user to the correct app store or website depending on the user's device, for example a smart link can redirect an iPhone user to the Apple App Store and an android user to the Google Play Store.\n\nThey are often used in marketing campaigns to track the effectiveness of different marketing efforts and to optimize the user experience.\n\nSmart short links are often dynamic where you can edit the target URL without the short link changing. This is great for printed QR codes.",
        ],
        tags: ["short link"],
      },
      {
        id: "what-is-an-url-shortener",
        title: "What is an URL shortener?",
        content: [
          "An URL shortener is a service where you can create short links and possibly dynamic short links. Instead of sharing the original long link, you can share a short link.",
        ],
        tags: ["short link"],
      },
      {
        id: "how-do-i-create-a-qr-code-for-downloading-an-app",
        title: "How do I create a QR Code for downloading an app?",
        content: [
          "With Onelink.to you can create a smart QR code that will help the user download your app on Google Play or Apple Appstore. It is completely automatic, you do not need to think about if the user has an Android or iOS device.",
        ],
        tags: ["qr code"],
      },
      {
        id: "how-do-i-create-a-qr-code-for-downloading-an-android-app",
        title: "How do I create a QR Code for downloading an Android app?",
        content: [
          "With Onelink.to you can create a smart QR code that will help the user download your Android app on Google Play or your iOS app on Apple Appstore. It is completely automatic, you do not need to think about which device the user has.",
        ],
        tags: ["qr code"],
        hidden: true,
      },
      {
        id: "how-do-i-create-a-qr-code-for-downloading-an-ios-app",
        title: "How do I create a QR Code for downloading an iOS app?",
        content: [
          "With Onelink.to you can create a smart QR code that will help the user download your iOS app on Apple Appstore or your Android app on Google Play. It is completely automatic, you do not need to think about which device the user has.",
        ],
        tags: ["qr code"],
        hidden: true,
      },
    ],
  },
  {
    id: "faq-general-questions",
    title: "Onelink - General Questions",
    items: [
      {
        id: "change-link-preview",
        title: "How do I change the link preview on social media like Facebook, WhatsApp, etc?",
        content: [
          "When sharing an Onelink URL on social media a preview will in many cases be generated by that service. Most (or perhaps all) social media services will generate this preview from your Fallback URL, as this is what they see. So to change preview behaviour, then do preview settings on your Fallback URL web page.",
        ],
        tags: ["general"],
      },
      {
        id: "chrome-on-ios-blank-appstore-screen",
        title: "Why do I get a blank screen when opening App Store links in Chrome on iOS?",
        content: [
          "We have occasionally seen an issue regarding Chrome as default browser on iOS where App Store links show up as a blank screen. This means it only affects a few per cent of iOS users.\n\nThis seems to be a bug in how Chrome retrieves data from the App Store, and seems to only affect apps with regional availability where you are currently in a region where the app is unavailable.\n\nIf you are having problems due to this issue, we recommend making your app available in more regions, or even globally available.",
        ],
        tags: ["general"],
      },
    ],
  },
];

export default FaqItems;
